export const ERROR_STRING = { 
    APPLICATION_SAVE_ERROR : "Error in saving application. Please try again.",
    RJSC_SEARCH_NO_STRING : "Enter either RJSC number or company name as per RJSC records.",
    RJSC_SEARCH_NO_RESULT : "Check your RJSC number and try again. If you don't know your number, you can look it up in RJSC.",
    RJSC_SEARCH_REQUEST_FAILED : "Could not search.. please try again later.",
    RJSC_STATUS_NOT_ACTIVE : "RJSC status must be active to continue. Update your information in RJSC before starting your licence application.",
    RJSC_OPERATING_NAME_TRADEMARK_NAME_BOTH_ENTERED : "Operating name and trademark name both can not be entered.",
    CONTACT_DETAILS_FIRST_NAME_EMPTY : "Enter first name.",
    CONTACT_DETAILS_LAST_NAME_EMPTY : "Enter last name.",
    CONTACT_DETAILS_NAME_EMPTY : "Enter name.",
    CONTACT_DETAILS_PHONE_EMPTY : "Enter a phone number",
    CONTACT_DETAILS_PHONE_INVALID : "Enter a 10 digit phone number",
    CONTACT_DETAILS_EMAIL_EMPTY : "Enter an email address",
    CONTACT_DETAILS_EMAIL_INVALID : "Enter a valid email address. Example: test@company.com",
    CONTACT_DETAILS_STREET_ADDRESS_EMPTY : "Enter a civic address",
    CONTACT_DETAILS_CITY_EMPTY : "Enter a city",
    CONTACT_DETAILS_POSTAL_CODE_EMPTY : "Enter a postal code",
    CONTACT_DETAILS_POSTAL_CODE_INVALID : "Enter a valid postal code",
    CONTACT_DETAILS_PROVINCE_EMPTY : "Select province",
    WORK_HISTORY_INCOMPLETE_PEOPLE_LIST : "Enter a description of each director, partner, and officers work history over the past 3 years",
    LICENCE_SUSPENSION_BUSINESS_TYPE_EMPTY : "Enter the type of business licence",
    LICENCE_SUSPENSION_PROVINCE_EMPTY : "Select a province",
    LICENCE_SUSPENSION_ACTION_EMPTY : "Select a licence action",
    LICENCE_SUSPENSION_DATE_INVALID : "Enter a valid date of when your licence was revoked, refused or suspended",
    LICENCE_SUSPENSION_DATE_EMPTY : "Enter a date of when your licence was revoked, refused or suspended",
    LICENCE_SUSPENSION_DATE_FUTURE : "Date can't be in the future",
    LICENCE_SUSPENSION_REASON_EMPTY : "Enter a reason why your licence was revoked, refused or suspended",
    ADDITIONAL_BRANCH_BRANCH_NAME_EMPTY : "Enter a branch name.",
    ADDITIONAL_BRANCH_ADDRESS_EMPTY : "Enter a branch civic address.",
    ADDITIONAL_BRANCH_ADDRESS_CITY_EMPTY : "Enter branch city/town",
    ADDITIONAL_BRANCH_ADDRESS_POSTAL_CODE_EMPTY : "Enter branch postal code",
    ADDITIONAL_BRANCH_ADDRESS_POSTAL_CODE_INVALID : "Enter a valid branch postal code",
    ADDITIONAL_BRANCH_MANAGER_NAME_EMPTY : "Enter a responsible agent name.",
    ADDITIONAL_BRANCH_MANAGER_PHONE_EMPTY : "Enter a phone number.",
    ADDITIONAL_BRANCH_MANAGER_PHONE_INVALID : "Enter a valid phone number.",
    ADDITIONAL_BRANCH_MANAGER_PHONE_NOT_10 : "Enter 10 digit phone number.",
    ADDITIONAL_BRANCH_MANGER_EMAIL_EMPTY : "Enter an email.",
    ADDITIONAL_BRANCH_MANAGER_EMAIL_INVALID : "Enter a valid email.",
    SURETY_BOND_DOC_MISSING: "Upload one copy of a surety bond",
    SUPPORTING_DOC_MISSING_FORM : "Upload one copy of each agreement your agency uses",
    SUPPORTING_DOC_MISSING_NOTICE : "Upload one copy of each notice or letter your collection agency uses",
    SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE : "File size of more than <file_size> is not supported. Please select a file with size less than <file_size>.",
    SUPPORTING_DOC_VERY_LARGE_TOTAL_FILE : "Total file size can not be more than <file_size>. Please select less number of files so that overall size is less than <file_size>.",
    SURETY_BOND_CONFIMRATION_NOT_CHECKED : "Please confirm that the surety bond will be sent via mail.",
    AGENT_DETAILS_ENTRY_CONFIRMATION_CHECK_BOXES_NOT_CLICKED : "Please confirm the age of applicant and business contact authority to proceed.",
    CONFIRM_BEFORE_PAYMENT_CONFIRMATION_NOT_CHECKED : "Please confirm before continuing.",
    CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT: "Please confirm before continuing.",
    PAYMENT_PREVIEW_PAYMENT_FAIL : "Payment can't be processed right now. Save and exit to come back later and try again without losing any of your information.",
    BLT_REVIEW_SECTION_INCOMPLETE : "Can not continue until all sections are marked either complete or incomplete",
    BLT_REVIEW_SECTION_NOT_ALL_COMPLETE : "Can not approve application if any section is marked \"incomplete\".",
    BLT_DECISION_NO_MESSAGE : "Please enter a message.",
    BLT_DECISION_NO_EMAIL : "Email address of the business contact not found. Can not send message.",
    BLT_REVIEW_DECISION_MESSAGE_DELIVERY_FAIURE : "Message could not be set. Please try again later.",
    AGENT_DETAILS_DELETE_ERROR : "Agent application could not be deleted. Please try again later.",
    AGENT_DETAILS_REMOVE_ERROR : "Agent application could not be removed. Please try again later.",
    UPLOAD_CERTIFICATE_ERROR : "Upload must be of type: Microsoft Word, Microsoft Excel, or PDF",
    AT_LEAST_ONE_FILE_MISSING_ERROR : "Please upload at least one file.",
    CHECK_FIELDS: "Please check the above fields",
    SELECT_AT_LEAST_ONE_OFFICER : "Please select one person from the list.",
    SELECT_COMPANY_RJSC_DETAIILS : "Select one reason for not having RJSC details.",
    LICENCE_NUMBER_EMPTY : "Enter licence number.",
    FINANCIAL_INSTITUTE_NAME_EMPTY : "Enter name of financial institution.",
    FINANCIAL_INSTITUTE_ADDRESS_EMPTY : "Enter branch address of the financial institution.",
    FINANCIAL_INSTITUTE_CITY_EMPTY : "Enter city of the financial institution.",
    FINANCIAL_INSTITUTE_ACCOUNT_NUMBER_EMPTY : "Enter financial institution account number.",
    FINANCIAL_INSTITUTE_ACCOUNT_NAME_EMPTY : "Enter financial institution account holder name.",
    PREVIOUS_LICENCE_STATUS_NOT_SELECTED : "Please select at least one of the options.",
    DATE_INVALID : "Date is invalid.",
    DATE_DAY_INVALID : "Day is invalid.",
    DATE_MONTH_INVALID : "Month is invalid.",
    DATE_YEAR_INVALID : "Year is invalid.",
    DATE_IN_FUTURE : "Date in future is invalid.",
    DATE_NOT_IN_FUTURE: "Date in past is invalid.",
    RENEWAL_APPLICATION_REVIEW_VALIDATION_ERROR : "Please update above fields before continuing.",
    CONFIRM_BEFORE_CONTINUE : "Please confirm before continuing.",
    INCOMPLETE_DATA : "Incomplete data.",
    CHANGE_REQUEST_REASON_EMPTY: "Enter a reason for this change request.",
}

export const VALIDATION_TYPE = {
    NAME : "name",
    PHONE_NUMBER : "phone_number",
    EMAIL : "email",
    LOCAL_ADDRESS : "local_address",
    CIVIC_ADDRESS : "civic_address",
    DATE_VALID : "date_valid",
    DATE_DAY : "date_day",
    DATE_MONTH : "date_month",
    DATE_YEAR : "date_year",
    STRING_NON_EMPTY : 'string_non_empty',
    CANADA_PROVINCE_CODE : "canada_province_code",
    CANADA_POSTAL_CODE : "canada_postal_code"
}

export const VALIDATION_ERROR = { 
    EMPTY : "empty",
    NAME_NOT_VALID : "name_not_valid",
    PHONE_NUMBER_INVALID : "phone_number_invalid",
    PHONE_NUMBER_NOT_10_DIGIT : "phone_number_not_10_digit",
    EMAIL_INVALID : "email_invalid",
    EMAIL_MISSIN_EMPERSANT : "email_missing_empersant",
    DATE_INVALID : "date_invalid",
    DATE_DAY_INVALID : "date_day_invalid",
    DATE_MONTH_INVALID : "date_month_invalid",
    DATE_YEAR_INVALID : "date_year_invalid",
    DATE_IN_FUTURE : "date_in_future",
    DATE_NOT_IN_FUTURE: "date_not_int_future",
    INCOMPLETE_PEOPLE_LIST : "incomplete_people_list",
    CANADA_PROVINCE_CODE_INVALID : "canada_province_code_invalid",
    CANADA_POSTAL_CODE_INVALID : "canada_postal_code_invalid",
    INCOMPLETE : "incomplete",
    SELECTION_INVALID : "selection_invalid",
    NO_ERROR : "no_error"
}

export function postalCodeErrorString(error) {
    switch(error) {
        case VALIDATION_ERROR.CANADA_POSTAL_CODE_INVALID : 
            return ERROR_STRING.CONTACT_DETAILS_POSTAL_CODE_INVALID
        case VALIDATION_ERROR.EMPTY : 
            return ERROR_STRING.CONTACT_DETAILS_POSTAL_CODE_EMPTY
        default : 
            return error
    }
}

export function phoneNumberErrorString(error) {
    switch(error) {
        case VALIDATION_ERROR.PHONE_NUMBER_INVALID : 
            return ERROR_STRING.CONTACT_DETAILS_PHONE_INVALID
        case VALIDATION_ERROR.PHONE_NUMBER_NOT_10_DIGIT : 
            return ERROR_STRING.CONTACT_DETAILS_PHONE_INVALID
        case VALIDATION_ERROR.EMPTY :
            return ERROR_STRING.CONTACT_DETAILS_PHONE_EMPTY
        default : 
            return error
    }
}

export function cityErrorString(error) {
    switch(error) {
        case VALIDATION_ERROR.EMPTY : 
            return ERROR_STRING.CONTACT_DETAILS_CITY_EMPTY
        default : 
            return error
    }
}

export function homeAddressErrorString(error) {
    switch(error) {
        case VALIDATION_ERROR.EMPTY :
            return ERROR_STRING.CONTACT_DETAILS_STREET_ADDRESS_EMPTY
        default : 
            return error
    }
}

export function emailErrorString(error) {
    switch(error) {
        case VALIDATION_ERROR.EMAIL_INVALID : 
            return ERROR_STRING.CONTACT_DETAILS_EMAIL_INVALID
        case VALIDATION_ERROR.EMPTY :
            return ERROR_STRING.CONTACT_DETAILS_EMAIL_EMPTY
        default : 
            return error
    }
}

export function dateValidationError(error) {
    switch(error) {
        case VALIDATION_ERROR.DATE_INVALID : 
            return ERROR_STRING.DATE_INVALID
        case VALIDATION_ERROR.DATE_DAY_INVALID : 
            return ERROR_STRING.DATE_DAY_INVALID
        case VALIDATION_ERROR.DATE_MONTH_INVALID :
            return ERROR_STRING.DATE_MONTH_INVALID
        case VALIDATION_ERROR.DATE_YEAR_INVALID:
            return ERROR_STRING.DATE_YEAR_INVALID
        case VALIDATION_ERROR.DATE_IN_FUTURE :
            return ERROR_STRING.DATE_IN_FUTURE
        case VALIDATION_ERROR.DATE_NOT_IN_FUTURE : 
            return ERROR_STRING.DATE_NOT_IN_FUTURE
        default : 
            return error
    }
}